import React from 'react';
import { Translate, useTranslate } from '@pegasus/translation';
import { AccountS as AccountIcon, ControlsArrowsPreviousXS as ControlsArrowsPrevious, NotificationS as NotificationIcon, SizeS as SizeIcon, PhoneS as PhoneIcon, ContactS as EnvelopeIcon, LoungeS as LoungeIcon, DeliveryS as DeliveryIcon, OrdersReturnS as OrdersIcon, } from '@lux/icons';
import { FunctionColor } from '@lux/core';
import { Text, Preset } from '@lux/text';
import { GridPageLayout } from '@lux/grid';
import { SubMenuName } from './types';
import { Wrapper, GoBack, BackIcon, Menu, Item, BackText, Icon } from './styles';
const menuItems = {
    [SubMenuName.none]: [],
    [SubMenuName.myaccount]: [
        {
            link: '/myaccount',
            translationKey: 'my-information',
            icon: AccountIcon,
        },
        {
            link: '/myaccount/addresses',
            translationKey: 'myAddresses',
            icon: DeliveryIcon,
            hidden: false,
        },
        {
            link: '/myaccount/order',
            translationKey: 'orders',
            icon: OrdersIcon,
        },
        {
            link: '/myaccount/newsletter',
            translationKey: 'newsletter',
            icon: NotificationIcon,
        },
        {
            link: '/myaccount/filter',
            translationKey: 'my-filter',
            icon: SizeIcon,
        },
    ],
    [SubMenuName.about]: [
        {
            specialLink: 'hotline-phone',
            translationKey: 'hotline',
            sublineTranslationKey: 'hotline-days',
            icon: PhoneIcon,
        },
        {
            link: '/contact',
            translationKey: 'contact',
            icon: EnvelopeIcon,
        },
        {
            link: '/aboutus',
            translationKey: 'about-us',
            icon: LoungeIcon,
        },
    ],
};
const isMenuItemWithLink = (menuItem) => 'link' in menuItem;
export const MobileSubMenu = ({ currSubMenu, closeSubmenu }) => {
    const translate = useTranslate('myaccount-submenu');
    return (React.createElement(Wrapper, { isOpen: currSubMenu !== SubMenuName.none },
        React.createElement(GridPageLayout, null,
            React.createElement(GoBack, { onClick: closeSubmenu },
                React.createElement(BackIcon, null,
                    React.createElement(ControlsArrowsPrevious, { "aria-labelledby": "myaccount-submenu-goback" })),
                React.createElement(BackText, { id: "myaccount-submenu-goback" },
                    React.createElement(Translate, { message: "go-back" })))),
        React.createElement(Menu, null, menuItems[currSubMenu].map((menuItem, index) => {
            const { sublineTranslationKey, translationKey, icon: MenuIcon } = menuItem;
            const link = isMenuItemWithLink(menuItem)
                ? menuItem.link
                : translate(menuItem.specialLink);
            return (React.createElement(Item, { index: index, href: link, key: translationKey, itemsLength: menuItems[currSubMenu].length, hidden: menuItem.hidden !== undefined && menuItem.hidden === true, "aria-labelledby": `myaccount-submenu-label-${translationKey}` },
                React.createElement(Icon, null,
                    React.createElement(MenuIcon, { width: "100%", height: "100%", color: FunctionColor.function100, stroke: "none", "aria-labelledby": `myaccount-submenu-label-${translationKey}` })),
                React.createElement(Text, { preset: Preset.S, id: `myaccount-submenu-label-${translationKey}` },
                    React.createElement(Translate, { message: translationKey }),
                    sublineTranslationKey && (React.createElement(React.Fragment, null,
                        React.createElement("br", null),
                        React.createElement(Translate, { message: sublineTranslationKey }))))));
        }))));
};
//# sourceMappingURL=index.js.map